/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AgentType = {
    FullTime: 'full_time',
    Agent1099: 'agent_1099'
} as const;
export type AgentType = typeof AgentType[keyof typeof AgentType];


export function AgentTypeFromJSON(json: any): AgentType {
    return AgentTypeFromJSONTyped(json, false);
}

export function AgentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentType {
    return json as AgentType;
}

export function AgentTypeToJSON(value?: AgentType | null): any {
    return value as any;
}

